import {
  ADDON_ROLE_SCOPES,
  isProjectScopedScope,
  isScope,
  MEMBER_ADDON_ROLES,
  SESSION_ROLE_SCOPES,
  type MemberAddonRole,
  type Scope,
} from "@cdx/shared/auth/scopes";
import {roleToLabel} from "./roles";

const ADDON_ROLE_ABILITY: Record<MemberAddonRole, string> = {
  integrationManager: "set up integrations",
  journeyTemplateEditor: "create and update Journey templates",
};

const REFUSAL_PREFIX = "requires ";

/** Returns the scope in dispatch's `requires <scope>` 403, or `null` for any other error message. */
export const parseScopeRefusal = (message: unknown): Scope | null => {
  if (typeof message !== "string" || !message.startsWith(REFUSAL_PREFIX)) return null;
  const scope = message.slice(REFUSAL_PREFIX.length);
  return isScope(scope) ? scope : null;
};

/** The refusal names no project, so a project-scoped scope cannot say which one. */
export const describeMissingScope = (scope: Scope): string => {
  const admins = `${roleToLabel.admin}s`;
  if (isProjectScopedScope(scope)) {
    return `Only producers of this project and ${admins} can do this.`;
  }
  if (SESSION_ROLE_SCOPES.user.has(scope)) {
    return `Only ${roleToLabel.guest} and ${admins} can do this.`;
  }
  const addonRole = MEMBER_ADDON_ROLES.find((role) => ADDON_ROLE_SCOPES[role].includes(scope));
  if (addonRole) {
    return `Only ${admins} and people allowed to ${ADDON_ROLE_ABILITY[addonRole]} can do this.`;
  }
  if (SESSION_ROLE_SCOPES.admin.has(scope)) return `Only ${admins} can do this.`;
  return `You don't have the '${scope}' permission.`;
};
